import React from "react";
import { FormattedMessage } from "react-intl";
import Body from "theme/components/atoms/Typography/Body";

const MaxLengthNote = ({ maxLength }) => {
  if (!maxLength) {
    return null;
  }
  return (
    <Body>
      <FormattedMessage
        id="components.organisms.Configurator.CustomOption.MaxLengthNote.message"
        defaultMessage="Maximum {maxLength} characters"
        values={{ maxLength }}
      />
    </Body>
  );
};

export default MaxLengthNote;
